var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var TextTile = function () {
	this.$tile = $( document.getElementsByClassName( 'text-tile' ) );
	this.$inner = $( document.querySelectorAll( '.text-tile > .inner' ) );
};

TextTile.prototype.init = function () {

	var self = this;

	var adjustment = ( ( self.$tile.height() - self.$inner.outerHeight() ) / 2 );
	self.$inner.css( 'margin-top', '-' + adjustment + 'px' );
};

module.exports = new TextTile();
